import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectDelivery, selectDispatchPoint, selectShowInvalids } from '@store/partners-order/selectors';
import { setDispatchPoint } from '@store/partners-order/slice';
import { Button } from 'react-aria-components';
import { invalidFormValue } from '@components/utils';
import { ScriptStatusEnum } from '@hooks/use-script/ScriptStatusEnum';
import { useScript } from '@hooks/use-script/useScript';
import { hasOwnPropertyTS, isZasilkovnaId } from '@components/utils';
import { DispatchPoint } from '@api/types/DispatchPoint';



const packetaOptions = {
	country: "cz,sk", 
	language: "cs", 
	valueFormat: "\"Packeta\",id,carrierId,carrierPickupPointId,name,city,street"
};


const Dispatch = () => {
	const { t } = useTranslation('forms');

	const delivery = useSelector(selectDelivery);
	const dispatchPoint = useSelector(selectDispatchPoint);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateDispatchPoint = (value: DispatchPoint | null) => dispatch(setDispatchPoint(value));

	const scriptStatus = useScript('https://widget.packeta.com/v6/www/js/library.js');


	const handlePickUp = useCallback((point: DispatchPoint & Record<string, unknown>) => {
		if (!point) return;
		updateDispatchPoint({
			id: point.id ? point.id : '-',
			name: point.name ? point.name : '-',
			place: point.place ? point.place : '-',
			street: point.street ? point.street : '-',
			city: point.city ? point.city : '-',
			zip: point.zip ? point.zip : '-',
			country: point.country ? point.country : '-',
			url: point.url ? point.url : '-',
		});
	},[]);


	if (!delivery || !isZasilkovnaId(delivery.id)) return (
		<></>
	)

	if (delivery && isZasilkovnaId(delivery.id) && scriptStatus === ScriptStatusEnum.loading) return (
		<div className='dispatch-point-section'>
			<label className='dispatch-point-label'>
				{t('paymentShipping.shipping.dispatchPointLabel') + ': '}<span>*</span>
			</label>
			<p className='packeta-selector-value'>{t('paymentShipping.loadingMessage')}</p>
		</div>
	)

	if (delivery && isZasilkovnaId(delivery.id) && scriptStatus === ScriptStatusEnum.error) return (
		<div className='dispatch-point-section'>
			<label className='dispatch-point-label'>
				{t('paymentShipping.shipping.dispatchPointLabel') + ': '}<span>*</span>
			</label>
			<p className='packeta-selector-value'>{t('paymentShipping.errorMessage')}</p>
		</div>
	)

	return (
		<div className='dispatch-point-section'>

			<label className='dispatch-point-label'>
				{t('paymentShipping.shipping.dispatchPointLabel') + ': '}<span>*</span> {showInvalids && delivery && isZasilkovnaId(delivery.id) && invalidFormValue(dispatchPoint) &&
					<p className='form-invalid'>{t('validation.requiredField')}</p>}
			</label>

			<div className='dispatch-point-text'>
				
				<p className='packeta-selector-value'>{dispatchPoint ? dispatchPoint.name : t('paymentShipping.shipping.notSelect')}</p>

				<Button className='app-form-button disable-selection packeta-selector-open' autoFocus={false} onPress={() => {
					if (hasOwnPropertyTS(window, 'Packeta')
						&& window.Packeta
						&& hasOwnPropertyTS(window.Packeta, 'Widget')
						&& window.Packeta.Widget
						&& hasOwnPropertyTS(window.Packeta.Widget, 'pick')
						&& window.Packeta.Widget.pick) {
							(window.Packeta.Widget as any).pick(process.env.PACKETA_API_KEY, handlePickUp, packetaOptions)
					}
				}}>
					{dispatchPoint ? t('shared.change') : t('shared.select')}
				</Button>

			</div>

		</div>
	);
};

export default Dispatch;